import { createSelector } from 'reselect';

import { AppState } from '../rootReducer';

const getItems = (state: AppState) => state.ARInvoice.items;
const getItemView = (state: AppState) => state.ARInvoice.itemView;

export const getARInvoiceSelector = createSelector(getItems, items => items);
export const getARInvoiceViewSelector = createSelector(getItemView, itemView => itemView);